export const zeroPadded = (numb: number) => (numb >= 10 ? numb.toString() : `0${numb}`);

const DEFAULT_DECIMAL = 8;

export const numFormat = (numbStr?: string | number, decimal?: number, defaultDecimal?: number) => {
  const numb = Number(numbStr);
  return isNaN(numb) ? numb : numb.toFixed(decimal ?? defaultDecimal ?? DEFAULT_DECIMAL);
};
